import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sort-up",
  "use": "icon-sort-up-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol viewBox=\"0 0 9 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sort-up\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.27955 0L8.56055 4.28025L7.50005 5.3415L5.02539 2.86684V9.75H3.52539V2.87551L1.06055 5.3415L4.78872e-05 4.28025L4.27955 0Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol